import React,{useEffect} from "react";
import "../CSS/ProjectsPage.css";
import prestige from "../Components/Assets/prestige.png";
import marie from "../Components/Assets/mariemadeit.png";
import rcs from "../Components/Assets/rcs.png";
import hangman from "../Components/Assets/hangman.png";
import weather from "../Components/Assets/weather.png";
import portfolio from "../Components/Assets/portfolio.png";
import tester from "../Components/Assets/tester.png";
import bookstore from "../Components/Assets/bookstore.png";
import littlelemon from "../Components/Assets/littlelemon.png";
import Contact from "../Components/Contact/Contact";

const ProjectsPage = () => {

  useEffect(()=>{window.scrollTo(0,0);},[]);

  const projects = [
    
    {
      id: 1 ,
      title: "MarieMadeIt - E-commerce Website",
      description:
        "A full-featured e-commerce platform with shopping cart, payment integration, and inventory management.",
      image: marie,
      skills: ["React", "CSS", "JavaScript", "Node.js", "MongoDB", "Paypal API", "Bootstrap"],
      demoLink: "https://mariemadeit.com/",
    },
    {
      id: 2,
      title: "Rodgers Consulting Services - Business Website",
      description:
        "Professional business website showcasing services, team members, and client testimonials.",
      image: rcs,
      skills: ["React", "CSS", "JavaScript", "Bootstrap"],
      demoLink: "https://www.inficonsult.com/",
    },
    {
      id: 3,
      title: "Hangman - Game Project",
      description:
        "A classic word-guessing game built with React, JavaScript, and TypeScript.",
      image: hangman,
      skills: ["React", "CSS", "JavaScript", "Bootstrap"],
      demoLink: "https://hangmansnp.netlify.app/",
    },
    {
      id: 4,
      title: "Prestige Online Supply House - E-commerce Website",
      description:
        "A full-featured e-commerce platform with shopping cart, payment integration, inventory management and Admin panel.",
      image: prestige,
      skills: ["React", "CSS", "JavaScript", "Node.js", "MongoDB", "Paypal API"],
      demoLink: "https://antuanfurtch.dev/projects",
    },
    {
      id: 5,
      title: "Developer Portfolio - Interactive Project Showcase",
      description:
        "A personal developer portfolio showcasing my projects, skills, and experience, built with a responsive design and interactive UI elements to create a modern and engaging user experience.",
      image: portfolio,
      skills: ["React", "CSS", "JavaScript"],
      demoLink: "#",
    },

    {
      id: 6 ,
      title: "Book Haven Bookstore - Online Bookstore Project",
      description:
        "An online bookstore application with a user-friendly interface for browsing and purchasing books.",
      image: bookstore,
      skills: ["React", "CSS", "JavaScript", "Node.js", "MongoDB"],
      demoLink: "https://bookstorehaven.netlify.app/",
    },
    {
      id: 7 ,
      title: "Weather App - Weather Forecasting Application",
      description:
        "Real-time weather application with location-based forecasts and detailed weather metrics.",
      image: weather,
      skills: ["API Integration", "React", "CSS", "JavaScript"],
      demoLink: "https://weatherapp-arf.netlify.app/",
    },
    {
      id: 8,
      title: "Little Lemon - Restaurant Website Project",
      description:
        "A modern restaurant website with an online reservation system and menu showcase.",
      image: littlelemon,
      skills: ["React", "CSS", "JavaScript", "Bootstrap"],
      demoLink: "https://littlelemonfurtch.netlify.app/",
    },
    {
      id: 9,
      title: "MarieMadeIt Tester - Crochet Tester Application",
      description:
        "A web application for testing and showcasing crochet patterns and techniques.",
      image: tester,
      skills: ["React", "CSS", "JavaScript"],
      demoLink: "https://mariemadeit-tester.netlify.app/",
    },
  ];

  return (
    <div className="projects-page">
      <div className="projects-page-header">
        <h1>My Projects</h1>
        <p>Explore my latest work and creative solutions</p>
      </div>

      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-grid-card">
            <div className="card-image">
              <img src={project.image} alt={project.title} />
            </div>

            <div className="card-body">
              <h3 className="card-title">{project.title}</h3>
              <p className="card-description">{project.description}</p>

              <div className="card-skills">
                {project.skills.map((skill, i) => (
                  <span key={i} className="skill-badge">
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            <div className="card-footer">
              <a href={project.demoLink} className="demo-link">
                View Demo
              </a>
            </div>
          </div>
        ))}
      </div>
      <Contact />
    </div>
  );
};

export default ProjectsPage;
